import React, { memo, useCallback } from 'react';
import { CustomTableCell } from '../../styles';
import { CustomTableCellForAccount, CustomTableCellRedirectToVoucher } from './tableCell';
import { TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { formatNumber } from '../../../../utils/common';
import { DEFAULT_DATE_FORMAT } from '../../../../config';

export const CustomTableRow = memo(({ data, index, handleTransationModal, accountDetails }) => {
  const handleTransactionClick = useCallback(() => {
    handleTransationModal(data.oppositeaccountid);
  }, [data]);

  return (
    <TableRow key={index + 'r'} className={`noTableCellBorder ${data.transactiontype == 'OpeningBalance' ? 'bold-td' : ''} `}>
      <CustomTableCell>{dayjs(data.enteredtimestamp * 1000).format(DEFAULT_DATE_FORMAT)}</CustomTableCell>
      <CustomTableCellForAccount onClick={handleTransactionClick} data={data} accountDetails={accountDetails} />
      <CustomTableCell>
        {data.transactiontype != 'OpeningBalance' ? (data.transactiontype == 'ManualJournal' ? 'Journal' : data.transactiontype) : ''}
      </CustomTableCell>
      <CustomTableCellRedirectToVoucher data={data} type={data.transactiontype}>
        {data.transactiontype == 'OpeningBalance' ? '' : data.vouchernumber}
      </CustomTableCellRedirectToVoucher>
      <CustomTableCell align="right">
        {data.transactiontype != 'OpeningBalance' ? formatNumber(data.totaldebitamount, false, true) : ''}
      </CustomTableCell>
      <CustomTableCell align="right">
        {data.transactiontype != 'OpeningBalance' ? formatNumber(data.totalcreditamount, false, true) : ''}
      </CustomTableCell>
      <CustomTableCell align="right" >
        {formatNumber(data?.balance, true, true, data.balancesign)}
      </CustomTableCell>
      <CustomTableCell sx={{  whiteSpace: 'nowrap', }}>
        {data.comments?.replace(/\*\*/g, '\n')}
      </CustomTableCell>
    </TableRow>
  );
});

export default TableRow;
